module.exports = __webpack_public_path__ + "static/media/email.b7541f62.svg";